import React from 'react';
import { Link } from 'react-router-dom';
import { T } from 'shared/helper/translate';
import ResendVerificationEmail from './ResendVerificationEmail';

/**
 * Explains the outcome of a verification link on the login page.
 *
 * Megatron redirects here with ?emailVerification=<outcome> after handling the
 * link, and separately refuses a login for an address that has not been verified.
 * @see AuthenticationController::verifyEmailAction
 */
var outcomeStyles = {
  'already-verified': 'alert-info',
  expired: 'alert-warning',
  invalid: 'alert-danger',
  verified: 'alert-success'
};
var outcomeMessages = {
  'already-verified': 'rubriq.email-already-verified',
  expired: 'rubriq.verification-link-expired',
  invalid: 'rubriq.verification-link-invalid',
  verified: 'rubriq.email-verified'
};

// Whichever of the two brought them here, an expired link means the account counts
// as never created: a fresh sign-up is the only way on, and resending is a dead end.
var needsNewSignUp = function needsNewSignUp(outcome, expired) {
  return expired || outcome === 'expired' || outcome === 'invalid';
};
var EmailVerificationNotice = function EmailVerificationNotice(_ref) {
  var outcome = _ref.outcome,
    _ref$registerLink = _ref.registerLink,
    registerLink = _ref$registerLink === void 0 ? '/register' : _ref$registerLink,
    required = _ref.required,
    expired = _ref.expired,
    email = _ref.email;
  var knownOutcome = outcome && outcomeMessages[outcome] ? outcome : null;
  if (!knownOutcome && !required) {
    return null;
  }

  // A refused login is the more actionable of the two, so it wins when a stale
  // outcome from the query string is still hanging around.
  var style = required ? 'alert-warning' : outcomeStyles[knownOutcome];
  var signUpAgain = needsNewSignUp(required ? null : knownOutcome, required && expired);
  var message = required ? expired && outcomeMessages.expired || 'rubriq.verify-email-before-login' : outcomeMessages[knownOutcome];
  return /*#__PURE__*/React.createElement("div", {
    className: "container pb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert shadow ".concat(style),
    role: "alert",
    "data-test": "email-verification-notice"
  }, /*#__PURE__*/React.createElement(T, {
    source: message
  }), ' ', signUpAgain && /*#__PURE__*/React.createElement(Link, {
    to: registerLink,
    "data-test": "email-verification-sign-up-again"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.sign-up-again"
  })), required && !expired && /*#__PURE__*/React.createElement(ResendVerificationEmail, {
    email: email
  })))));
};
export default EmailVerificationNotice;